import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/work1',
    name: 'work1',
    component: () => import('../views/WorkView.vue'),
    meta: { title: 'work1'}
  },
  {
    path: '/work2',
    name: 'work2',
    component: () => import('../views/WorkView2.vue'),
    meta: { title: 'work2'}
  },
  {
    path: '/work3',
    name: 'work3',
    component: () => import('../views/WorkView3.vue'),
    meta: { title: 'work3'}
  },
  {
    path: '/work4',
    name: 'work4',
    component: () => import('../views/WorkView4.vue'),
    meta: { title: 'work4'}
  },
  {
    path: '/work5',
    name: 'work5',
    component: () => import('../views/WorkView5.vue'),
    meta: { title: 'work5'}
  },
  {
    path: '/work6',
    name: 'work6',
    component: () => import('../views/WorkView6.vue'),
    meta: { title: 'work6'}
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
